/**
 * Tidy up a WhatsApp message for display.
 * WhatsApp posts often contain excessive blank lines and trailing spaces
 * (decorative spacing, copy-paste artifacts). This collapses them so the
 * "Show message" reveal stays compact.
 *
 *  - Trims leading/trailing whitespace
 *  - Strips trailing spaces on each line
 *  - Collapses 3+ consecutive newlines into a single blank line
 *  - Collapses runs of 2+ spaces (within a line) into one
 */
export function tidyOriginalMessage(text?: string | null): string {
  if (!text) return '';
  return String(text)
    .replace(/\r\n/g, '\n')
    .replace(/[ \t]+\n/g, '\n')      // trailing spaces on each line
    .replace(/\n{2,}/g, '\n')        // multiple blank lines → single newline
    .replace(/[ \t]{2,}/g, ' ')      // multiple spaces in a line → one
    .trim();
}
